import { WebPlugin } from "@capacitor/core"
import type { AppleAuthPlugin, AppleSignInResponse } from "./definitions"

export class AppleAuthWeb extends WebPlugin implements AppleAuthPlugin {
	async signIn(): Promise<AppleSignInResponse> {
		throw new Error("Sign in with Apple is only available in the iOS app.")
	}
}
